import ClickAwayListener, { ClickAwayListenerProps } from '@material-ui/core/ClickAwayListener';

export type DSClickAwayListenerProps = ClickAwayListenerProps;

export const DSClickAwayListener = ClickAwayListener;
